import { motion, AnimatePresence } from 'motion/react';
import { useFileStore } from '../../stores/fileStore';
import { FileItem } from './FileItem';
import { FolderItem } from './FolderItem';

export function FileGrid() {
  const { files, folders } = useFileStore();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.03,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 20 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 25,
      },
    },
    exit: {
      opacity: 0,
      scale: 0.9,
      transition: { duration: 0.15 },
    },
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="space-y-1"
    >
      <AnimatePresence mode="popLayout">
        {folders.map((folder) => (
          <motion.div
            key={folder.id}
            variants={itemVariants}
            layout
            layoutId={`folder-${folder.id}`}
          >
            <FolderItem folder={folder} viewMode="list" />
          </motion.div>
        ))}

        {files.map((file) => (
          <motion.div
            key={file.id}
            variants={itemVariants}
            layout
            layoutId={`file-${file.id}`}
          >
            <FileItem file={file} viewMode="list" />
          </motion.div>
        ))}
      </AnimatePresence>
    </motion.div>
  );
}
